<template>
  <div :class="[loading ? 'loading-card' : '', 'stripe-card-form']">
    <div class="loading-icon" />

    <div class="card-fields">
      <div class="card-field-group card-number">
        <div
          id="card-number"
          class="input-field"
        />

        <div
          id="cardErr"
          class="card-errors"
        />
      </div>

      <div class="card-field-group card-cvc">
        <div
          id="card-cvc"
          class="input-field"
        />

        <div
          id="cvcErr"
          class="card-errors"
        />
      </div>

      <div class="card-field-group card-exp">
        <div
          id="card-exp"
          class="input-field"
        />

        <div
          id="cardExpErr"
          class="card-errors"
        />
      </div>

      <div
        id="card-errors"
        class="card-errors"
      />
    </div>

    <div
      v-if="includechecks == 'true' && !loading"
      class="card-check-boxes"
    >
      <input
        id="f1consent"
        v-model="f1Consent"
        type="checkbox"
        class="f1consent"
        value="true"
        @change="$emit('update-f1', f1Consent)"
      >

      <label
        class="f1consent"
        for="f1consent"
      >
        {{ $t('creditCardForm.f1Consent') }}
      </label>
    </div>

    <button
      class="continue-button btn btn-primary"
      @click="generateCardId"
    >
      {{ buttontext }}
    </button>
  </div>
</template>

<script>
import StripeJS from './stripe.js'

export default {
  props: {
    address: {
      default: null,
      required: true,
      type: String,
    },

    address2: {
      default: null,
      required: false,
      type: String,
    },

    buttontext: {
      default: null,
      required: true,
      type: String,
    },

    city: {
      default: null,
      required: true,
      type: String,
    },

    includechecks: {
      default: 'false',
      required: true,
      type: String,
    },

    name: {
      default: null,
      required: true,
      type: String,
    },

    phone: {
      default: null,
      required: false,
      type: String,
    },

    state: {
      default: null,
      required: false,
      type: String,
    },

    zipcode: {
      default: null,
      required: true,
      type: String,
    }
  },

  data() {
    return {
      displayError: null,
      f1Consent: false,
      loading: false,
    }
  },

  computed: {
    billingDetails() {
      return {
        address: {
          city: this.city || '',
          line1: this.address || '',
          line2: this.address2 || '',
          postal_code: this.zipcode || '',
          state: this.state || ''
        },
        name: this.name || '',
        phone: this.phone || ''
      }
    },

    displayErrorClass() {
      if (this.displayError == this.displayErrorText) {
        return 'card-errors'
      } else {
        return 'hidden'
      }
    },

    displayErrorText() {
      return this.$t('creditCardForm.pleaseAccept')
    },

    disableSubmit() {
      if (this.includechecks == 'true' && this.acceptedTerms == false) {
        return true
      } else {
        return false
      }
    }
  },

  beforeDestroy() {
    StripeJS.removeElements()
  },

  mounted() {
    StripeJS.generateForm()
  },

  methods: {
    generateCardId() {
      // Don't submit button twice
      if (this.loading) { return }

      // Don't process if acceptedTermsAndConditions are false
      if (this.disableSubmit) {
        this.displayError = this.displayErrorText
        return
      }

      this.loading = true
      StripeJS.cardIDToBeChargedImmediately(this.billingDetails).then(cardId => {
        if (cardId === 'error') {
          // Stripe will generate errors here
          this.loading = false
        } else {
          this.$emit('card-added', { id: cardId, stripe: StripeJS })
        }
      })
    },
  },
}
</script>
